import schemaValidator from '@sitebase/schema-validator';

const validate = (name, schema, data) => {
  const { success, error } = schemaValidator(schema, data);
  if (!success) {
    console.error(`${name} data validation error: ${error}`);
    throw new Error('Message Bus data validation failure');
  }
};

export const makePublishHelper = (name, topic, schema) => data => {
  if (schema) validate(name, schema, data);
  return {
    topic,
    data,
  };
};

export const makeSubscribeHelper = (name, topic, schema) => callback => ({
  topic,
  callback: (...args) => {
    const data = typeof args[0] === 'string' ? args[1] : args[0].data;
    if (schema) validate(name, schema, data);
    callback(data);
  },
});
